
  import { Vue, Component, Prop } from "vue-property-decorator";

  import SearchableDocumentsList from "@/components/documents/SearchableDocumentsList.vue";
  import DocumentItem from "@/components/documents/DocumentItem.vue";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import ContractorsMultiselect from "@/components/autocompleteMultiselects/ContractorsMultiselectNew.vue";
  import DocumentUserInformation from "@/components/documents/DocumentUserInformation.vue";
  import DocumentIcon from "@/components/icons/DocumentIcon.vue";

  import getContractorsMultiselectConditions from '@/helpers/getContractorsMultiselectConditions';
  import { User } from "@/generated/graphql";

  @Component({
    components: {
      SearchableDocumentsList,
      DocumentItem,
      CardBodyItem,
      ContractorsMultiselect,
      DocumentUserInformation,
      DocumentIcon,
    },
  })
  export default class ContractorsDocumentsFilteredList extends Vue {
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: Object, default: () => ({}) }) readonly queryObject!: Object;

    selectedContractorsIds: string[] = [];
    filtersTouched: boolean = false;

    get query(): Object {
      return {
        _and: [
          this.queryObject,
          this.getContractorFilterConditions(),
          { uploaded_by: { _eq: this.currentUser.id } },
          { attached_to: { user: { role: { _eq: "CONTRACTOR" } } } },
        ],
      };
    }

    onContractorSelected(selectedContractorsIds: string[]): void {
      this.selectedContractorsIds = selectedContractorsIds;
      this.filtersTouched = true;
    }

    getContractorFilterConditions(): Object {
      if (this.selectedContractorsIds.length === 0) {
        return {};
      }

      const conditions = this.selectedContractorsIds.map((contractorId) => ({
        attached_to: {
          user: {
            contracts: {
              id: {
                _eq: contractorId,
              },
            },
          },
        },
      }));

      return { _or: conditions };
    }

    get contractorsListConditions(): Object {
      return getContractorsMultiselectConditions(this.currentUser.role)
    }
  }
